import React, { PureComponent } from 'react';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Day from '../day';

const DayNames = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-content: center;
  font-weight: bold;
  font-size: 1.3em;
  grid-column-gap: 0.4em;
  grid-row-gap: 0.4em;
  padding: 0 0.4em 0 0.4em;
  margin: 0 0.4em 0 0.4em;
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  justify-content: center;
  font-weight: bold;
  font-size: 1.3em;
  grid-column-gap: 0.4em;
  grid-row-gap: 0.4em;
  padding: 0 0.4em 0 0.4em;
  margin: 0 0.4em 0 0.4em;
  overflow-y: auto;
`;

const Weekday = styled.div`
  text-align: center;
  padding: 0.5em 0;
  font-weight: bold;
  text-indent: 0.3em;
`;

/**
 * Date selector
 * Used to dynamically render a month worth of days
 * @reactProps {object} month The date to show the current month for
 * @reactProps {function(date: string): void} onClick Callback to pass to down to days
 */
class DateSelector extends PureComponent {
  /**
   * Calculate the percetange of timeslots booked for that day
   */
  getDateInfo = unixDay => {
    if (!this.props.dateInfo) {
      return { loading: true };
    }
    if (!this.props.dateInfo[unixDay]) {
      return null;
    }
    return this.props.dateInfo[unixDay];
  };

  /**
   * Get all days in the month
   */
  getDaysInMonth = startDate => {
    const daysInMonth = Array.from(Array(startDate.daysInMonth()).keys(), i =>
      startDate.add(i, 'day')
    );
    return daysInMonth.map((date, i) => (
      <Day
        date={date}
        key={date.toISOString()}
        onClick={this.props.onClick}
        style={i === 0 ? { gridColumn: `${startDate.day() + 1}` } : null}
        {...this.getDateInfo(date.unix())}
      />
    ));
  };

  /**
   * @inheritDoc
   */
  render() {
    return (
      <>
        <DayNames>
          {dayjs()
            .localeData()
            .weekdaysShort()
            .map(day => (
              <Weekday key={day}>{day}</Weekday>
            ))}
        </DayNames>
        <Container>
          {this.getDaysInMonth(this.props.month.startOf('month'))}
        </Container>
      </>
    );
  }
}

DateSelector.propTypes = {
  month: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  dateInfo: PropTypes.object
};

export default DateSelector;
